
const formdata = state => state.formdata;
const data = state => param => state.data[param];
const dataobject = state => state.data;
const specifications = state => state.specifications;
const getsingle = state => param =>state.specifications.find((a)=> a.id == param)

export default {
  formdata,
  data,
  dataobject,
  specifications,
  getsingle
};